var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlashIconIndigo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Flash-2--Streamline-Core",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Flash 2 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flash-2--flash-power-connect-charge-electricity-lightning"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#8783d1",
    fillRule: "evenodd",
    d: "M8.5 0.499976c0 -0.219014 -0.14253 -0.4125364 -0.35169 -0.4774987 -0.20916 -0.0649623 -0.43625 0.0137578 -0.56033 0.1942347l-5.5 7.999998c-0.10519 0.15301 -0.11693 0.35171 -0.03049 0.51604 0.08644 0.16433 0.25683 0.26723 0.44251 0.26723h3V13.5c0 0.219 0.14254 0.4125 0.35169 0.4775 0.20916 0.0649 0.43625 -0.0138 0.56033 -0.1943L11.912 5.78324c0.1052 -0.15301 0.117 -0.35171 0.0305 -0.51604 -0.0864 -0.16433 -0.2568 -0.26722 -0.4425 -0.26722h-3V0.499976Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashIconIndigo);
export default __webpack_public_path__ + "static/media/flash-icon-indigo.0fd87dbfd599c27b66976b635dd98641.svg";
export { ForwardRef as ReactComponent };